"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OlympusConference = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const ResourceType_1 = require("../../ResourceType");
const CardName_1 = require("../../CardName");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const CardRenderer_1 = require("../render/CardRenderer");
class OlympusConference extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.OLYMPUS_CONFERENCE,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.EARTH, Tags_1.Tags.BUILDING],
            cost: 10,
            resourceType: ResourceType_1.ResourceType.SCIENCE,
            metadata: {
                cardNumber: '185',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.science().played.colon().science().br;
                    b.or().br;
                    b.minus().science().plus().cards(1);
                }),
                description: 'When you play a Science tag, including this, either add a Science resource to this card, or remove a Science resource from this card to draw a card.',
                victoryPoints: 1,
            },
        });
        this.resourceCount = 0;
    }
    onCardPlayed(player, card) {
        if (!player.cardIsInEffect(this.name))
            return;
        const scienceTags = card.tags.filter((tag) => tag === Tags_1.Tags.SCIENCE).length;
        for (let i = 0; i < scienceTags; i++) {
            player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
                if (this.resourceCount === 0) {
                    player.addResourceTo(this, 1);
                    return undefined;
                }
                return new OrOptions_1.OrOptions(new SelectOption_1.SelectOption('Remove a science resource from this card to draw a card', 'Remove resource', () => {
                    player.removeResourceFrom(this);
                    player.drawCard();
                    return undefined;
                }), new SelectOption_1.SelectOption('Add a science resource to this card', 'Add resource', () => {
                    player.addResourceTo(this, 1);
                    return undefined;
                }));
            }), -1);
        }
        return undefined;
    }
    play() {
        return undefined;
    }
    getVictoryPoints() {
        return 1;
    }
}
exports.OlympusConference = OlympusConference;
//# sourceMappingURL=OlympusConference.js.map